<template>
    <div class="layout-container">
        <el-tabs type="border-card"  v-model="activeName"  @tab-click="handleClick">
            <el-tab-pane label="站点" name="站点">
              <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-if="activeName == '站点'" v-model="siteCondition.site_id" :owned='true' :dataType=1 :init-choose-first="false" ref="siteAutoCompleteSite" clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time-2">
                            <span class="label">时间段</span>
                            <div>
                                <a  @click="siteCheckDate('month')"  :class="this.siteCondition.timeStamp == 'month' ? 'active quckily' : 'quckily'">最近30天</a>
                                <a class="quckily" @click="siteCheckDate('doubleMonth')" :class="siteCondition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                            </div>
                            <div class="input-condition">
                                <el-date-picker
                                    v-model="siteCondition.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="请选择开始日期"
                                    end-placeholder="请选择结束日期"
                                    align="right"
                                    @change="siteCondition.timeStamp = ''"
                                    :picker-options="pickerOptions"
                                    >
                                </el-date-picker>
                            </div>
                        </div>
                     
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch1()">查 询</el-button>
                        <el-button  @click="resetSearch(1)">清空条件</el-button>
                        <el-button-group class="floatR" style="margin-left:20px;" v-if="siteDataList.length">
                            <el-tooltip class="item" effect="dark" content="导出" placement="top">
                                <el-button icon="el-icon-download" @click="downloadSite"></el-button>
                            </el-tooltip>
                        </el-button-group>  
                    </div>
              </div>
                <div class="totalData" v-if="siteTotal">
                    <div class="item">
                        <p><span>{{siteTotal.mobiles.mobile_count}}</span><span>(去重：{{siteTotal.mobiles.distinct_mobile_count}})</span></p>
                        <label>400线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{siteTotal.ims.mobile_count}}</span><span>(去重：{{siteTotal.ims.distinct_mobile_count}})</span></p>
                        <label>IM线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{siteTotal.forms.mobile_count}}</span><span>(去重：{{siteTotal.forms.distinct_mobile_count}})</span></p>
                        <label>表单线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{siteTotal.sums.mobile_count}}</span><span>(去重：{{siteTotal.sums.distinct_mobile_count}})</span></p>
                        <label>合计线索量</label>
                    </div>
                </div>
                <el-table
                        :data="siteDataList.slice((siteCurPage-1)*sitePageSize,siteCurPage*sitePageSize)"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable1"
                        v-loading="isLoading"
                        @sort-change="siteSortChange"
                        header-cell-class-name="table-back"
                >
                    <el-table-column label="站点" prop="site_name">
                        <template scope="scope">
                            <a class="goDate"  @click="goDate(scope.row.site_id)">{{scope.row.site_name}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="400线索量" prop="mobile" sortable='custom'  >
                        <template scope="scope">
                            <span>{{scope.row.mobile}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="400线索量(去重)" prop="distinct_mobile">
                        <template scope="scope">
                            <span>{{scope.row.distinct_mobile}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="IM线索量" prop="im" sortable='custom'>
                        <template scope="scope" >
                            <span>{{scope.row.im}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="IM线索量(去重)" prop="distinct_im">
                        <template scope="scope" >
                            <span>{{scope.row.distinct_im}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="表单线索量" prop="form" sortable='custom'>
                        <template scope="scope">
                            <span>{{scope.row.form}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="表单线索量(去重)" prop="distinct_form">
                        <template scope="scope">
                            <span>{{scope.row.distinct_form}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合计线索量" prop="sum" sortable='custom'>
                        <template scope="scope">
                            <span>{{scope.row.sum}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合计线索量(去重)" prop="distinct_sum">
                        <template scope="scope">
                            <span>{{scope.row.distinct_sum}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="siteDataList.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="siteCurPage"  :total="siteDataList.length" :page-size="sitePageSize" @current-change="siteCurrentChange"></el-pagination>
                </template>
            </el-tab-pane>
            <el-tab-pane label="日期" name="日期">
                 <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-if="activeName == '日期'" v-model="dateCondition.site_id" :owned='true' :clueId=1 :init-choose-first="false" ref="siteAutoCompleteDate" clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time-2">
                            <span class="label">时间段</span>
                            <div>
                                <a class="quckily" @click="dateCheckDate('month')" :class="dateCondition.timeStamp == 'month' && 'active'">最近30天</a>
                                <a class="quckily" @click="dateCheckDate('doubleMonth')" :class="dateCondition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                            </div>
                            <div class="input-condition">
                                <el-date-picker
                                    v-model="dateCondition.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="请选择开始日期"
                                    end-placeholder="请选择结束日期"
                                    align="right"
                                    @change="dateCondition.timeStamp = ''"
                                    :picker-options="pickerOptions"
                                    >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch2()">查 询</el-button>
                        <el-button  @click="resetSearch(2)">清空条件</el-button>
                        <el-button-group class="floatR" style="margin-left:20px;">
                            <el-tooltip class="item" effect="dark" content="导出" placement="top" v-if="dateDataList.length">
                                <el-button icon="el-icon-download" @click="downloadDate"></el-button>
                            </el-tooltip>
                        </el-button-group>  
                    </div>
                </div>
                <div class="totalData" v-if="dateTotal">
                    <div class="item">
                        <p><span>{{dateTotal.mobiles.mobile_count}}</span><span>(去重：{{dateTotal.mobiles.distinct_mobile_count}})</span></p>
                        <label>400线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{dateTotal.ims.mobile_count}}</span><span>(去重：{{dateTotal.ims.distinct_mobile_count}})</span></p>
                        <label>IM线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{dateTotal.forms.mobile_count}}</span><span>(去重：{{dateTotal.forms.distinct_mobile_count}})</span></p>
                        <label>表单线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{dateTotal.sums.mobile_count}}</span><span>(去重：{{dateTotal.sums.distinct_mobile_count}})</span></p>
                        <label>合计线索量</label>
                    </div>
                </div>
                <el-table
                        :data="dateDataList.slice((dateCurPage-1)*datePageSize,dateCurPage*datePageSize)"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable2"
                        v-loading="isLoading"
                        @sort-change="dateSortChange"
                        header-cell-class-name="table-back"
                >
                    <el-table-column label="站点" prop="site_name"></el-table-column>
                    <el-table-column label="日期" prop="date_time" sortable='custom'  >
                    </el-table-column>
                    <el-table-column label="400线索量" prop="mobile" sortable='custom'  >
                        <template scope="scope">
                            <span>{{scope.row.mobile}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="400线索量(去重)" prop="mobile">
                        <template scope="scope">
                            <span>{{scope.row.distinct_mobile}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="IM线索量" prop="im" sortable='custom'  >
                        <template scope="scope" >
                            <span>{{scope.row.im}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="IM线索量(去重)" prop="distinct_im">
                        <template scope="scope" >
                            <span>{{scope.row.distinct_im}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="表单线索量" prop="form" sortable='custom'>
                        <template scope="scope">
                            <span>{{scope.row.form}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="表单线索量(去重)" prop="distinct_form">
                        <template scope="scope">
                            <span>{{scope.row.distinct_form}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合计线索量" prop="sum" sortable='custom'>
                        <template scope="scope">
                            <span>{{scope.row.sum}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合计线索量(去重)" prop="distinct_sum">
                        <template scope="scope">
                            <span>{{scope.row.distinct_sum}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="dateDataList.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="dateCurPage"  :total="dateDataList.length" :page-size="datePageSize" @current-change="dateCurrentChange"></el-pagination>
                </template>
            </el-tab-pane>
             <el-tab-pane label="终端" name="终端">
                 <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con show">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-if="activeName == '终端'" v-model="terminalCondition.site_id" :owned='true' :clueId=1 :init-choose-first="false" ref="siteAutoCompleteTerminal" clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition terminal">
                            <span class="label">来源终端</span>
                            <div class="input-condition">
                                <el-select v-model="terminalCondition.terminal_id" placeholder="请选择" @change="changeTerminal">
                                    <el-option v-for="item in terminals" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                                <el-select v-model="terminalCondition.extendId" placeholder="请选择" v-if="terminalCondition.terminal_id == 3 || terminalCondition.terminal_id == 4">
                                    <el-option v-for="item in terminalExtend" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time-2">
                            <span class="label">时间段</span>
                            <div>
                                <a class="quckily" @click="terminalCheckDate('month')" :class="terminalCondition.timeStamp == 'month' && 'active'">最近30天</a>
                                <a class="quckily" @click="terminalCheckDate('doubleMonth')" :class="terminalCondition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                            </div>
                            <div class="input-condition">
                                <el-date-picker
                                    v-model="terminalCondition.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="请选择开始日期"
                                    end-placeholder="请选择结束日期"
                                    align="right"
                                    @change="terminalCondition.timeStamp = ''"
                                    :picker-options="pickerOptions"
                                    >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch3()">查 询</el-button>
                        <el-button  @click="resetSearch(3)">清空条件</el-button>
                        <el-button-group class="floatR" style="margin-left:20px;" v-if="terminalDataList.length">
                            <el-tooltip class="item" effect="dark" content="导出" placement="top">
                                <el-button icon="el-icon-download" @click="downloadTerminal"></el-button>
                            </el-tooltip>
                        </el-button-group>  
                    </div>
                </div>
                <div class="totalData" v-if="terminalTotal">
                    <div class="item">
                        <p><span>{{terminalTotal.mobiles.mobile_count}}</span><span>(去重：{{terminalTotal.mobiles.distinct_mobile_count}})</span></p>
                        <label>400线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{terminalTotal.ims.mobile_count}}</span><span>(去重：{{terminalTotal.ims.distinct_mobile_count}})</span></p>
                        <label>IM线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{terminalTotal.forms.mobile_count}}</span><span>(去重：{{terminalTotal.forms.distinct_mobile_count}})</span></p>
                        <label>表单线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{terminalTotal.sums.mobile_count}}</span><span>(去重：{{terminalTotal.sums.distinct_mobile_count}})</span></p>
                        <label>合计线索量</label>
                    </div>
                </div>
                <el-table
                        :data="terminalDataList.slice((terminalCurPage-1)*terminalPageSize,terminalCurPage*terminalPageSize)"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable3"
                        v-loading="isLoading"
                        @sort-change="terminalSortChange"
                        header-cell-class-name="table-back"
                >
                    <el-table-column label="站点" prop="site_name"></el-table-column>
                    <el-table-column label="来源终端" prop="terminal_name"   >
                    </el-table-column>
                    <el-table-column label="IM线索量" prop="im" sortable='custom'  >
                        <template scope="scope" >
                            <span>{{scope.row.im}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="IM线索量(去重)" prop="distinct_im">
                        <template scope="scope" >
                            <span>{{scope.row.distinct_im}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="表单线索量" prop="form" sortable='custom'>
                        <template scope="scope">
                            <span>{{scope.row.form}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="表单线索量(去重)" prop="distinct_form">
                        <template scope="scope">
                            <span>{{scope.row.distinct_form}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合计线索量" prop="sum" sortable='custom'>
                        <template scope="scope">
                            <span>{{scope.row.sum}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合计线索量(去重)" prop="distinct_sum">
                        <template scope="scope">
                            <span>{{scope.row.distinct_sum}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="terminalDataList.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="terminalCurPage"  :total="terminalDataList.length" :page-size="terminalPageSize" @current-change="terminalCurrentChange"></el-pagination>
                </template>
            </el-tab-pane>
             <el-tab-pane label="楼盘" name="楼盘">
                 <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con show">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-if="activeName == '楼盘'" v-model="houseCondition.site_id" :owned='true' :init-choose-first="true" @created="initDataHouse" ref="siteAutoCompleteHouse" clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition" v-if="houseCondition.site_id!=0">
                            <span class="label">区域</span>
                            <div class="input-condition">
                                <site-area-cascader v-if="activeName == '楼盘'"  v-model="houseCondition.area_id" :site-id="houseCondition.site_id" :emit-path="false" ref="houseAutoCompleteHouse"  clearable></site-area-cascader>
                            </div>
                        </div>
                        <div class="search-condition" v-if="houseCondition.site_id!=0">
                            <span class="label">楼盘</span>
                            <div class="input-condition">
                                <house-auto-complete v-if="activeName == '楼盘'" v-model="houseCondition.house_id" :site-id="houseCondition.site_id" ref="areaAutoCompleteHouse" clearable></house-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time-2">
                            <span class="label">时间段</span>
                            <div>
                                <a class="quckily" @click="houseCheckDate('month')" :class="houseCondition.timeStamp == 'month' && 'active'">最近30天</a>
                                <a class="quckily" @click="houseCheckDate('doubleMonth')" :class="houseCondition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                            </div>
                            <div class="input-condition">
                                <el-date-picker
                                    v-model="houseCondition.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="请选择开始日期"
                                    end-placeholder="请选择结束日期"
                                    align="right"
                                    @change="houseCondition.timeStamp = ''"
                                    :picker-options="pickerOptions"
                                    >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch4()">查 询</el-button>
                        <el-button  @click="resetSearch(4)">清空条件</el-button>
                        <el-button-group class="floatR" style="margin-left:20px;" v-if="houseDataList.length">
                            <el-tooltip class="item" effect="dark" content="导出" placement="top">
                                <el-button icon="el-icon-download" @click="downloadHouse"></el-button>
                            </el-tooltip>
                        </el-button-group>  
                    </div>
                </div>
                  <div class="totalData" v-if="houseTotal">
                    <div class="item">
                        <p><span>{{houseTotal.mobiles.mobile_count}}</span><span>(去重：{{houseTotal.mobiles.distinct_mobile_count}})</span></p>
                        <label>400线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{houseTotal.ims.mobile_count}}</span><span>(去重：{{houseTotal.ims.distinct_mobile_count}})</span></p>
                        <label>IM线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{houseTotal.forms.mobile_count}}</span><span>(去重：{{houseTotal.forms.distinct_mobile_count}})</span></p>
                        <label>表单线索量</label>
                    </div>
                    <div class="item">
                        <p><span>{{houseTotal.sums.mobile_count}}</span><span>(去重：{{houseTotal.sums.distinct_mobile_count}})</span></p>
                        <label>合计线索量</label>
                    </div>
                </div>
                <el-table
                        :data="houseDataList.slice((houseCurPage-1)*housePageSize,houseCurPage*housePageSize)"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable4"
                        v-loading="isLoading"
                        @sort-change="houseSortChange"
                        header-cell-class-name="table-back"
                >
                    <el-table-column label="站点" prop="site_name"></el-table-column>
                    <el-table-column label="区域" prop="areas_info"></el-table-column>
                    <el-table-column label="楼盘名称" prop="house_name"></el-table-column>
                    <el-table-column label="400线索量" prop="mobile" sortable='custom'>
                        <template scope="scope">
                            <span>{{scope.row.mobile}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="400线索量(去重)" prop="mobile">
                        <template scope="scope">
                            <span>{{scope.row.distinct_mobile}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="IM线索量" prop="im" sortable='custom'>
                        <template scope="scope" >
                            <span>{{scope.row.im}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="IM线索量(去重)" prop="distinct_im">
                        <template scope="scope" >
                            <span>{{scope.row.distinct_im}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="表单线索量" prop="form" sortable='custom'>
                        <template scope="scope">
                            <span>{{scope.row.form}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="表单线索量(去重)" prop="distinct_form">
                        <template scope="scope">
                            <span>{{scope.row.distinct_form}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合计线索量" prop="sum" sortable='custom'>
                        <template scope="scope">
                            <span>{{scope.row.sum}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="合计线索量(去重)" prop="distinct_sum">
                        <template scope="scope">
                            <span>{{scope.row.distinct_sum}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="houseDataList.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="houseCurPage"  :total="houseDataList.length" :page-size="housePageSize" @current-change="houseCurrentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
    import { parseTime } from '@/utils'
    import { getTerminalsNew , getCustomerSite ,getCustomerDate ,getCustomerTerminal,getCustomerHouse} from '@/service/customer'
    import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";
    import SiteAreaCascader from "../../../components/auto-complete/site-area-cascader";
    import HouseAutoComplete from "../../../components/auto-complete/house-auto-complete";

    export default {
        name: "List",
        components: {
            SiteAutoComplete,
            SiteAreaCascader,
            SiteAutoComplete,
            HouseAutoComplete,
        },
        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },
                activeName:'站点',//当前Tab名称
                siteName:"",
                toDateSite:null,
                isLoading: true,
                siteCondition:{ //站点
                    site_id:0,
                    time:null,
                    timeStamp: 'month',
                },
                lastSiteCondition:null,
                siteCurPage:1,
                sitePageSize:10,
                siteTotal:null,
                siteDataList:[],
                dateCondition:{ //日期
                    site_id: '',
                    time: '',
                    timeStamp: 'month',
                },
                lastDateCondition:null,
                dateCurPage:1,
                datePageSize:10,
                dateTotal:null,
                dateDataList:[],
                terminalCondition:{ //终端
                    site_id: 0,
                    time: '',
                    timeStamp: 'month',
                    terminal_id:0,
                    extendId:null
                },
                lastTerminalCondition:null,
                terminalCurPage:1,
                terminalPageSize:10,
                terminals:[
                    {
                        id : 0,
                        name : '全部'
                    }
                ],
                terminalExtend:[
                    {
                        id :null,
                        name : '全部'
                    }
                ],
                terminalTotal:null,
                terminalDataList:[],
                houseCondition:{ //楼盘
                    site_id: 0,
                    area_id:0,
                    house_id:0,
                    time: '',
                    timeStamp: 'month',
                },
                lastHouseCondition:null,
                houseCurPage:1,
                housePageSize:10,
                houseTotal:null,
                houseDataList:[],

            }
        },
        mounted () {
            if(this.$route.query.tab){
                this.activeName =this.$route.query.tab
            }
            this.getTerminals()
            this.initDataSite()
        },
        methods: {
            handleClick(tab, event) { //tab切换
                this.isLoading=true
                if(this.activeName == '站点'){
                    this.initDataSite()
                }
                if(this.activeName == '日期'){
                    this.initDataDate()
                }
                if(this.activeName == '终端'){
                    this.initDataTerminal()
                }
                if(this.activeName == '楼盘'){
                    this.$nextTick(() => {
                        this.$refs.siteAutoCompleteHouse&& this.$refs.siteAutoCompleteHouse.reset();
                    })
                }
            },
            resetSearch(type){
             
                switch (type) {
                    case 1:
                        this.siteCondition={
                            site_id:0,
                            time:null,
                            timeStamp: 'month',
                        }
                        this.$refs.multipleTable1.columns.forEach(item => {
                            item.order = ''
                        })
                        this.siteCurPage = 1
                        this.$nextTick(() => {
                            this.$refs.siteAutoCompleteSite && this.$refs.siteAutoCompleteSite.reset();
                        })
                        this.initDataSite()
                        break;
                    case 2:
                        this.dateCondition={
                            site_id:0,
                            time:null,
                            timeStamp: 'month',
                        }
                        this.$refs.multipleTable2.columns.forEach(item => {
                            item.order = ''
                        })
                        this.dateCurPage = 1
                        this.$nextTick(() => {
                            this.$refs.siteAutoCompleteDate && this.$refs.siteAutoCompleteDate.reset();
                        })
                        this.initDataDate()
                        break;
                    case 3:
                        this.terminalCondition={
                           site_id: 0,
                            time: '',
                            timeStamp: 'month',
                            terminal_id:0,
                            extendId:null
                        }
                        this.$refs.multipleTable3.columns.forEach(item => {
                            item.order = ''
                        })
                        this.terminalCurPage = 1
                        this.$nextTick(() => {
                            this.$refs.siteAutoCompleteTerminal && this.$refs.siteAutoCompleteTerminal.reset();
                        })
                        this.initDataTerminal()
                        break;
                    case 4:
                        this.houseCondition={
                            site_id: '',
                            area_id:0,
                            house_id:0,
                            time: '',
                            timeStamp: 'month',
                        }
                         this.$refs.multipleTable2.columns.forEach(item => {
                            item.order = ''
                        })
                        this.houseCurPage = 1;
                        this.$nextTick(() => {
                            this.$refs.siteAutoCompleteHouse&& this.$refs.siteAutoCompleteHouse.reset();
                        })
                    default:
                        
                        break;
                }
               
            },
             exportPathMethod(data,condition) { //导出
	            /*
	            *注：csv文件：","逗号换列，\n换行，\t防止excel将长数字变科学计算法等样式
	            */
	            //要导出的json数据
	            let mainLists = data.trade   //主表
	            let _self = this
	            //## 数据处理
	            //一级表
	            let mainTitle = mainLists.tHeader;//一级标题
	            let mainTitleForKey = mainLists.filterVal;//一级过滤
	            let mainList = mainLists.list;//一级数据
	            let mainStr = [];
	            mainStr.push(mainTitle.join("\t,")+"\n");   //标题添加上换列转成字符串并存进数组
	            for(let i=0;i<mainList.length;i++){
	                let temp = [];
	                for(let j=0;j<mainTitleForKey.length;j++){
	                    temp.push(mainList[i][mainTitleForKey[j]]); //根据过滤器拿出对应的值
	                }
	                mainStr.push(temp.join("\t,")+"\n");    //取出来的值加上逗号换列转字符串存数组
	            }	
	            //两个表数组转成字符串合并
	            let merged = mainStr.join("")	            
	            //## 导出操作
	            // encodeURIComponent解决中文乱码
	            const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(merged)
	            // 通过创建a标签实现
	            let link = document.createElement('a')
	            link.href = uri
                 let name =this.siteName+ '购房数据（'+this.activeName+'）';
               let timeStart=''
                let timeEnd=''
                timeStart =parseTime(condition.start_time,'{y}-{m}-{d}')
                timeEnd = parseTime(condition.end_time,'{y}-{m}-{d}')
                name += timeStart+'至'+timeEnd
	            // 对下载的文件命名
                link.download = name+'.csv'
	            document.body.appendChild(link)
	            link.click()
	        },
            //站点
            siteCheckDate (value) {
                this.siteCondition = Object.assign({}, this.siteCondition, {
                    timeStamp: value,
                    time: ''
                })
            },
            siteSortChange(column){//站点排序
                let order ='';
                if(column.order == 'descending'){
                    order='desc'
                }else{
                    order='asc'
                }
                if(!this.siteCondition.site_id){
                    this.siteCondition.site_id=0
                }
                this.siteCurPage=1
                this.siteCondition.sort_name =column.prop
                this.siteCondition.sort_order =order
                this.initDataSite()
            },
            handleSearch1() {
                this.siteCurPage = 1
                this.initDataSite()
            },
            async initDataSite() {
                 this.isLoading = true
                let query =this.siteCondition
                if (this.siteCondition.timeStamp.length > 0) {
                    let time_quantum = this.siteCondition.timeStamp == 'month' ? 30 : 60
                    query.start_time = Date.parse(new Date())/1000 - time_quantum * 24 * 3600
                    query.end_time = Date.parse(new Date())/1000
                } else if(this.siteCondition.time && this.siteCondition.time.length > 0) {
                    query.start_time = Date.parse(new Date(this.siteCondition.time[0]))/1000
                    query.end_time = Date.parse(new Date(this.siteCondition.time[1]))/1000
                } else {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return
                }
                if(!query.site_id){
                    query.site_id=0
                }
                this.lastSiteCondition=JSON.parse(JSON.stringify(query))
                await getCustomerSite(query).then((data) => {
                    if(data.list.length == 0){
                         this.siteDataList=data.list;
                        this.siteTotal=null
                    }else{
                        this.siteDataList=data.list;
                        this.siteTotal=data.all
                    }
                  
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
                /* 数据请求完毕取消当前页面的loading */
                this.isLoading = false;
            },
            async downloadSite(){
                let _self=this;
                let query =_self.lastSiteCondition;
                query.export=1;
                await getCustomerSite(query).then((res) => {
                    let data =res.list;
                    if(query.site_id!=0){
                        this.siteName=data[0].site_name
                    }
                   
                    // data.forEach(el => {
                    //     el.mobile_str=el.mobile+'（去重：'+el.distinct_mobile+'）'
                    //     el.im_str=el.im+'（去重：'+el.distinct_im+'）'
                    //     el.form_str=el.form+'（去重：'+el.distinct_form+'）'
                    //     el.sum_str=el.sum+'（去重：'+el.distinct_sum+'）'
                    // });
                    let jsonData = {
                            trade:{
                                tHeader: ["站点","400线索量","400线索量(去重)","IM线索量","IM线索量(去重)","表单线索量","表单线索量(去重)","合计线索量","合计线索量(去重)"],
                                filterVal: ["site_name","mobile","distinct_mobile","im","distinct_im","form","distinct_form","sum","distinct_sum"],
                                list: data
                            }
                        }    
                        _self.exportPathMethod(jsonData,query)// 调用exportPathMethod对数据进行处理导出
                        _self.exportShow=false
                   
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
            },
            siteCurrentChange (index) {
                this.siteCurPage = index
            },
            goDate(siteId){
                this.activeName="日期";
                this.dateCondition.site_id=siteId;
                this.initDataDate()
            },
            //日期
            dateCheckDate (value) {
                this.dateCondition = Object.assign({}, this.dateCondition, {
                    timeStamp: value,
                    time: ''
                })
            },
            dateCurrentChange (index) {
                this.dateCurPage = index
            },
            dateSortChange(column){//站点排序
                if(!this.dateDataList.length){
                    return
                }
                let order ='';
                let value ='';
                if(column.order == 'descending'){
                    order='desc'
                }else{
                    order='asc'
                }
                if(column.prop == "date_time"){
                    value = 'date'
                }else{
                    value=column.prop
                }
                if(!this.dateCondition.site_id){
                    this.dateCondition.site_id=0
                }
                this.dateCurPage=1
                this.dateCondition.sort_name =value
                this.dateCondition.sort_order =order
                this.initDataDate()
            },
            handleSearch2() {
                this.dateCurPage = 1
                this.initDataDate()
            },
            async initDataDate(){
                this.isLoading = true
                let query =this.dateCondition
                if (this.dateCondition.timeStamp.length > 0) {
                    let time_quantum = this.dateCondition.timeStamp == 'month' ? 30 : 60
                    query.start_time = Date.parse(new Date())/1000 - time_quantum * 24 * 3600
                    query.end_time = Date.parse(new Date())/1000
                } else if(this.dateCondition.time && this.dateCondition.time.length > 0) {
                    query.start_time = Date.parse(new Date(this.dateCondition.time[0]))/1000
                    query.end_time = Date.parse(new Date(this.dateCondition.time[1]))/1000
                } else {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return
                }
                if(!query.site_id){
                    query.site_id=0
                }
                this.lastDateCondition=JSON.parse(JSON.stringify(query))
                await getCustomerDate(query).then((data) => {

                    if(data.list.length == 0){
                        this.dateDataList=[];
                        this.dateTotal=null
                    }else{
                        this.dateDataList=data.list;
                        this.dateTotal=data.all
                    }
                   
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
                /* 数据请求完毕取消当前页面的loading */
                this.isLoading = false;
            },
            async downloadDate(){
                let _self=this;
                let query =_self.lastDateCondition;
                query.export=1;
                await getCustomerDate(query).then((res) => {
                    let data =res.list;
                    this.siteName=data[0].site_name
                    // data.forEach(el => {
                    //     el.mobile_str=el.mobile+'（去重：'+el.distinct_mobile+'）'
                    //     el.im_str=el.im+'（去重：'+el.distinct_im+'）'
                    //     el.form_str=el.form+'（去重：'+el.distinct_form+'）'
                    //     el.sum_str=el.sum+'（去重：'+el.distinct_sum+'）'
                    // });
                    let jsonData = {
                            trade:{
                                tHeader: ["站点","日期","400线索量","400线索量(去重)","IM线索量","IM线索量(去重)","表单线索量","表单线索量(去重)","合计线索量","合计线索量(去重)"],
                                filterVal: ["site_name","date_time","mobile","distinct_mobile","im","distinct_im","form","distinct_form","sum","distinct_sum"],
                                list: data
                            }
                        }    
                        _self.exportPathMethod(jsonData,query)// 调用exportPathMethod对数据进行处理导出
                        _self.exportShow=false
                   
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
            },
            //终端
            getTerminals(){
                getTerminalsNew({}).then((data) => {
                    this.terminals = this.terminals.concat(data)
                })
            },
            changeTerminal(val){
                this.terminalExtend=[
                    {
                        id :null,
                        name : '全部'
                    }
                ],
                this.terminalCondition.extendId=null;
                if(val == 3 || val ==4 ){
                    let obj =this.terminals.filter(item => item.id === val)
                    this.terminalExtend =this.terminalExtend.concat(obj[0].expend)
                }
            },
            terminalSortChange(column){
                if(!this.terminalDataList.length){
                    return
                }
                let order ='';
                if(column.order == 'descending'){
                    order='desc'
                }else{
                    order='asc'
                }
                
                if(!this.terminalCondition.site_id){
                    this.terminalCondition.site_id=0
                }
                this.terminalCurPage=1;
                this.terminalCondition.sort_name =column.prop
                this.terminalCondition.sort_order =order
                this.initDataTerminal()
            },
            handleSearch3() {
                this.terminalCurPage = 1
                this.initDataTerminal()
            },
            async initDataTerminal(){
                this.isLoading = true
                let query =JSON.parse(JSON.stringify(this.terminalCondition))
                if (this.terminalCondition.timeStamp.length > 0) {
                    let time_quantum = this.terminalCondition.timeStamp == 'month' ? 30 : 60
                    query.start_time = Date.parse(new Date())/1000 - time_quantum * 24 * 3600
                    query.end_time = Date.parse(new Date())/1000
                } else if(this.terminalCondition.time && this.terminalCondition.time.length > 0) {
                    query.start_time = Date.parse(new Date(this.terminalCondition.time[0]))/1000
                    query.end_time = Date.parse(new Date(this.terminalCondition.time[1]))/1000
                } else {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return
                }
                if(!query.site_id){
                    query.site_id=0
                }
                if(this.terminalCondition.extendId>0){
                    query.terminal_id=this.terminalCondition.extendId;
                }
                this.lastTerminalCondition=JSON.parse(JSON.stringify(query))
                await getCustomerTerminal(query).then((data) => {
                    if(data.list.length == 0){
                        this.terminalDataList=[];
                        this.terminalTotal=null
                    }else{
                        this.terminalDataList=data.list;
                        this.terminalTotal=data.all
                    }
                   
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
                /* 数据请求完毕取消当前页面的loading */
                this.isLoading = false;
            },
            terminalCheckDate (value) {
                this.terminalCondition = Object.assign({}, this.terminalCondition, {
                    timeStamp: value,
                    time: ''
                })
            },
            terminalCurrentChange(index){
                this.terminalCurPage = index
            },
            async downloadTerminal(){
                let _self=this;
                let query =_self.lastTerminalCondition;
                query.export=1;
                await getCustomerTerminal(query).then((res) => {
                    let data =res.list;
                    this.siteName=data[0].site_name
                    // data.forEach(el => {
                    //     el.im_str=el.im+'（去重：'+el.distinct_im+'）'
                    //     el.form_str=el.form+'（去重：'+el.distinct_form+'）'
                    //     el.sum_str=el.sum+'（去重：'+el.distinct_sum+'）'
                    // });
                    let jsonData = {
                            trade:{
                                tHeader: ["站点","终端","IM线索量","IM线索量(去重)","表单线索量","表单线索量(去重)","合计线索量","合计线索量(去重)"],
                                filterVal: ["site_name","terminal_name","im","distinct_im","form","distinct_form","sum","distinct_sum"],
                                list: data
                            }
                        }    
                    _self.exportPathMethod(jsonData,query)// 调用exportPathMethod对数据进行处理导出
                    _self.exportShow=false
                   
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
            },
             //楼盘
            houseSortChange(column){
                if(!this.houseDataList.length){
                    return
                }
                let order ='';
                if(column.order == 'descending'){
                    order='desc'
                }else{
                    order='asc'
                }
                
                if(!this.houseCondition.site_id){
                    this.houseCondition.site_id=0
                }
                this.houseCurPage=1;
                this.houseCondition.sort_name =column.prop
                this.houseCondition.sort_order =order
                this.initDataHouse()
            },
            handleSearch4() {
                this.houseCurPage = 1
                this.initDataHouse()
            },
            async initDataHouse(){
                this.isLoading = true                
                let query =this.houseCondition
                if (this.houseCondition.timeStamp.length > 0) {
                    let time_quantum = this.houseCondition.timeStamp == 'month' ? 30 : 60
                    query.start_time = Date.parse(new Date())/1000 - time_quantum * 24 * 3600
                    query.end_time = Date.parse(new Date())/1000
                } else if(this.houseCondition.time && this.houseCondition.time.length > 0) {
                    query.start_time = Date.parse(new Date(this.houseCondition.time[0]))/1000
                    query.end_time = Date.parse(new Date(this.houseCondition.time[1]))/1000
                } else {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return
                }
                if(!query.house_id){
                    query.house_id=0
                }
                 if(!query.area_id){
                    query.area_id=0
                }
                this.lastHouseCondition=JSON.parse(JSON.stringify(query))
                await getCustomerHouse(query).then((data) => {
                    if(data.list.length == 0){
                        this.houseDataList=[];
                        this.houseTotal=null
                    }else{
                        this.houseDataList=data.list;
                        this.houseTotal=data.all
                    }
                   
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
                /* 数据请求完毕取消当前页面的loading */
                this.isLoading = false;
            },
            houseCheckDate (value) {
                this.houseCondition = Object.assign({}, this.houseCondition, {
                    timeStamp: value,
                    time: ''
                })
            },
            houseCurrentChange (index) {
                this.houseCurPage = index
            },
            async downloadHouse(){
                let _self=this;
                let query =_self.lastHouseCondition;
                query.export=1;
                await getCustomerHouse(query).then((res) => {
                    let data =res.list;
                    this.siteName=data[0].site_name
                    // data.forEach(el => {
                    //     el.mobile_str=el.mobile+'（去重：'+el.distinct_mobile+'）'
                    //     el.im_str=el.im+'（去重：'+el.distinct_im+'）'
                    //     el.form_str=el.form+'（去重：'+el.distinct_form+'）'
                    //     el.sum_str=el.sum+'（去重：'+el.distinct_sum+'）'
                    // });
                    let jsonData = {
                            trade:{
                                tHeader: ["站点","区域","楼盘名称","400线索量","400线索量(去重)","IM线索量","IM线索量(去重)","表单线索量","表单线索量(去重)","合计线索量","合计线索量(去重)"],
                                filterVal: ["site_name","areas_info","house_name","mobile","distinct_mobile","im","distinct_im","form","distinct_form","sum","distinct_sum"],
                                list: data
                            }
                        }    
                    _self.exportPathMethod(jsonData,query)// 调用exportPathMethod对数据进行处理导出
                    _self.exportShow=false
                   
                }).catch(err => {
                    this.$message({
                        message: err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                });
            },
        }
    }
</script>

<style scoped>
    .totalData{
        height: 100px;
        margin: 30px 40px 0;
    }
    .totalData .item{
        width: 15%;
        float: left;
        line-height: 30px;
        font-size: 14px;
        text-align: center;
    }

   .search-condition-con .terminal{
        width: 28%;
        max-width: 500px;
    }
    .terminal .el-select{
        width: 40%;
        float: left;
        margin-right: 10px;
    }
    .goDate{
        cursor: pointer;
        color:#409EFF;
    }

</style>
